export enum ComponentVariant {
  DEFAULT = 'default',
  GREEN = 'green',
  BLUE = 'blue',
}

// Common card classes
export const CARD_BASE_CLASSES =
  'bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-3 md:py-6 shadow-sm';

export const CARD_GLASSMORPHISM_CLASSES =
  'bg-white/75 backdrop-blur-sm border border-white/30 shadow-lg text-card-foreground flex flex-col gap-6 rounded-xl py-3 md:py-6 overflow-hidden';

export const CARD_VARIANT_CLASSES: Record<ComponentVariant, string> = {
  [ComponentVariant.DEFAULT]: `${CARD_BASE_CLASSES} border-[var(--border-main)]`,
  [ComponentVariant.GREEN]: `${CARD_BASE_CLASSES} border-green-200`,
  [ComponentVariant.BLUE]: `${CARD_BASE_CLASSES} border-blue-200`,
};

// Common dialog classes
export const DIALOG_BASE_CLASSES =
  'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg';

export const DIALOG_GLASSMORPHISM_CLASSES =
  'bg-white/85 backdrop-blur-md border border-white/40 shadow-xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-xl p-6 duration-200 sm:max-w-lg';

export const DIALOG_VARIANT_CLASSES: Record<ComponentVariant, string> = {
  [ComponentVariant.DEFAULT]: DIALOG_BASE_CLASSES,
  [ComponentVariant.GREEN]: `${DIALOG_BASE_CLASSES.replace('border ', 'border border-green-400 ')}`,
  [ComponentVariant.BLUE]: `${DIALOG_BASE_CLASSES.replace('border ', 'border border-blue-400 ')}`,
};
